import { IonBadge, IonButton, IonButtons, IonCol, IonGrid, IonIcon, IonRow, IonText } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React from 'react';

interface Props {
    produtos: any[];
    valorTotal: string;
    tipoRetirada: string;
    onNext: () => void;
    onBack: () => void;
    onEditarCardapio: () => void;
}

const TelaRevisao: React.FC<Props> = ({ produtos, valorTotal, tipoRetirada, onNext, onBack, onEditarCardapio }) => {

    function calcularValorTotal(): string {
        const total = produtos.reduce((acc: number, item: any) => {
            return acc + parseFloat((item.subtotal || '0').toString().replace(/\./g, '').replace(/,/g, '.'));
        }, 0);
        return total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function getNomeProduto(item: any): string {
        if (item.descricao && Array.isArray(item.descricao)) {
            if (item.tipo === 'pizzas') {
                const sabores = item.descricao.filter((d: any) => d.categoria !== 'Observação').map((d: any) => d.descricao).join(', ');
                return `${item.tamanho || ''} ${item.quantidadeSabores || ''} sabores - ${sabores}`;
            }
            return item.descricao.filter((d: any) => d.categoria !== 'Observação').map((d: any) => d.descricao).join(', ');
        }
        return item.descricao || 'Produto';
    }

    function getObservacao(item: any): string {
        if (item.descricao && Array.isArray(item.descricao)) {
            const obs = item.descricao.find((d: any) => d.categoria === 'Observação');
            return obs?.descricao || '';
        }
        return '';
    }

    const labelRetirada = tipoRetirada === 'comer_aqui' ? 'Comer Aqui' : tipoRetirada === 'levar' ? 'Para Levar' : tipoRetirada;

    return (
        <div className="totem-tela-revisao">
            <div className="totem-tela-header">
                <IonButtons>
                    <IonButton fill="clear" color="medium" onClick={onBack} className="totem-btn-voltar">
                        <IonIcon icon={arrowBack} slot="icon-only" />
                    </IonButton>
                </IonButtons>
                {/* <h2>Revise seu pedido</h2>
                <IonButton fill="clear" color="danger" onClick={onEditarCardapio}>
                    <IonIcon icon={createOutline} slot="start" /> Editar
                </IonButton> */}
            </div>

            <div className="totem-tela-body">

                <h2>Revise seu pedido</h2>
                {/* <p>Digite seu nome para personalizar o pedido</p> */}
                <div className="totem-revisao-tipo">
                    <IonBadge color="danger">{labelRetirada}</IonBadge>
                </div>

                <div className="totem-revisao-card">
                    {/* Cabeçalho colunas */}
                    <IonGrid className="totem-revisao-grid">
                        <IonRow className="totem-revisao-grid-header">
                            <IonCol size="1" className="ion-text-center">#</IonCol>
                            <IonCol size="6">DESCRIÇÃO</IonCol>
                            <IonCol size="2" className="ion-text-center">QTDE</IonCol>
                            <IonCol size="3" className="ion-text-end">VALOR</IonCol>
                        </IonRow>

                        {produtos.map((item: any, idx: number) => {
                            const obs = getObservacao(item);
                            return (
                                <React.Fragment key={idx}>
                                    <IonRow className="totem-revisao-grid-row">
                                        <IonCol size="1" className="ion-text-center">
                                            <IonText color="medium">{idx + 1}</IonText>
                                        </IonCol>
                                        <IonCol size="6">
                                            <strong>{getNomeProduto(item)}</strong>
                                            {obs && <div className="totem-revisao-obs">Obs: {obs}</div>}
                                        </IonCol>
                                        <IonCol size="2" className="ion-text-center">
                                            <span className="totem-revisao-qtd">{item.quantidade}</span>
                                        </IonCol>
                                        <IonCol size="3" className="ion-text-end">
                                            <strong>R$ {typeof item.subtotal === 'string' ? item.subtotal : Number(item.subtotal || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong>
                                        </IonCol>
                                    </IonRow>
                                </React.Fragment>
                            );
                        })}
                    </IonGrid>

                    <div className="totem-revisao-total">
                        <span>Total</span>
                        <span className="totem-revisao-total-valor">R$ {calcularValorTotal()}</span>
                    </div>
                </div>
            </div>

            <div className="totem-tela-actions">
                <IonButton className="totem-btn" expand="block" color="danger" onClick={onNext}>
                    Ir para Pagamento
                </IonButton>
            </div>
        </div>
    );
};

export default TelaRevisao;
